function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import styled, { css } from 'styled-components';
var TRANSITION = '0.2s ease';
export var Nav = styled.nav.withConfig({
  displayName: "elements__Nav",
  componentId: "sc-5n6fy9-0"
})(["display:flex;padding:0;background-color:", ";overflow-x:auto;", ""], function (_ref) {
  var palette = _ref.theme.palette;
  return palette.white;
}, function (_ref2) {
  var isVertical = _ref2.isVertical;
  return isVertical && css(["flex-direction:column;"]);
});

var ActiveItem = function ActiveItem(_ref3) {
  var isVertical = _ref3.isVertical;
  return isVertical ? css(["color:", ";&,&:hover{background-color:", ";}:disabled,:disabled:hover{background-color:", ";}"], function (_ref4) {
    var palette = _ref4.theme.palette;
    return palette.white;
  }, function (_ref5) {
    var palette = _ref5.theme.palette;
    return palette.primary["default"];
  }, function (_ref6) {
    var palette = _ref6.theme.palette;
    return palette.lightGrey;
  }) : css(["color:", ";&,&:hover{border-bottom-color:", ";}:disabled{color:", ";border-bottom-color:", ";}"], function (_ref7) {
    var palette = _ref7.theme.palette;
    return palette.darkBlue;
  }, function (_ref8) {
    var palette = _ref8.theme.palette;
    return palette.primary["default"];
  }, function (_ref9) {
    var palette = _ref9.theme.palette;
    return palette.spaceGrey;
  }, function (_ref10) {
    var palette = _ref10.theme.palette;
    return palette.spaceGrey;
  });
};

export var Item = styled.span.withConfig({
  displayName: "elements__Item",
  componentId: "sc-5n6fy9-1"
})(["text-align:center;cursor:pointer;white-space:nowrap;font-size:", ";font-weight:", ";color:", ";", " &.active{", "}", " ", " ", ""], function (_ref11) {
  var size = _ref11.theme.fonts.size;
  return size.big;
}, function (_ref12) {
  var weight = _ref12.theme.fonts.weight;
  return weight.normal;
}, function (_ref13) {
  var palette = _ref13.theme.palette;
  return palette.spaceGrey;
}, function (_ref14) {
  var isActive = _ref14.isActive,
      props = _objectWithoutProperties(_ref14, ["isActive"]);

  return isActive && ActiveItem(props);
}, ActiveItem, function (_ref15) {
  var isVertical = _ref15.isVertical;
  return !isVertical && css(["border-bottom:0.3rem solid;border-bottom-color:transparent;padding:1.4rem 0 1.1rem 0;transition:border-color ", ",color ", ";&:not(:last-child){margin-right:2rem;}:hover{border-bottom-color:", ";}:disabled{cursor:not-allowed;opacity:0.6;border-bottom-color:transparent;}"], TRANSITION, TRANSITION, function (_ref16) {
    var palette = _ref16.theme.palette;
    return palette.veryLightBlue;
  });
}, function (_ref17) {
  var isVertical = _ref17.isVertical;
  return isVertical && css(["border-radius:", ";text-align:left;padding:0.9rem 1.6rem;transition:background-color ", ",color ", ";:hover{background:", ";}:disabled{cursor:not-allowed;opacity:0.6;}:disabled:hover{background-color:transparent;}"], function (_ref18) {
    var dimensions = _ref18.theme.dimensions;
    return dimensions.radius;
  }, TRANSITION, TRANSITION, function (_ref19) {
    var palette = _ref19.theme.palette;
    return palette.veryLightGrey;
  });
}, function (_ref20) {
  var isFluid = _ref20.isFluid;
  return isFluid && css(["flex:1 1 0;"]);
});